import * as React from 'react';

var _path;
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var SvgReturns = function SvgReturns(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        width: 24,
        height: 24,
        fill: "none",
        "aria-hidden": "true",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.78.22a.75.75 0 0 1 0 1.06L6.56 4.5H17.94l-3.22-3.218A.75.75 0 1 1 15.78.222L20.06 4.5h1.291a2.237 2.237 0 0 1 2.084 2.796l-.298 1.248a.75.75 0 0 1-1.46-.348l.3-1.256.005-.018A.732.732 0 0 0 21.309 6H3.19a.733.733 0 0 0-.673.921l.005.02 2.137 9 .004.014c.068.312.34.537.658.545h3.553a.75.75 0 0 1 0 1.5H5.3a2.192 2.192 0 0 1-2.1-1.72L1.064 7.297A2.234 2.234 0 0 1 3.15 4.5h1.29L8.72.22a.75.75 0 0 1 1.06 0Zm8.654 11.79a4.822 4.822 0 0 0-4.891 3.25.75.75 0 1 1-1.419-.486 6.32 6.32 0 0 1 11.376-1.25V12a.75.75 0 0 1 1.5 0v3.75a.75.75 0 0 1-.75.75H20.5a.75.75 0 0 1 0-1.5h2.07a4.822 4.822 0 0 0-4.136-2.99ZM13 22.5v-1.524a6.324 6.324 0 0 0 11.377-1.25.75.75 0 0 0-1.42-.486 4.822 4.822 0 0 1-9.027.26H16a.75.75 0 0 0 0-1.5h-3.75a.75.75 0 0 0-.75.75v3.75a.75.75 0 0 0 1.5 0Z",
        fill: "currentColor"
    })));
};

export { SvgReturns as default };
//# sourceMappingURL=returns-9d9a846b.js.map
